import { createSlice } from '@reduxjs/toolkit'

export const searchTextSlice = createSlice({
  name: 'searchtext',
  initialState: {
    value: ''
  },
  reducers: {
    setsearchText: (state,action) => {
      state.value = action.payload
    }
   
  }
})

export const { setsearchText } = searchTextSlice.actions

export default searchTextSlice.reducer